<mat-accordion [multi]="false"  *ngIf="vo$ | async; let vo" >
	<mat-expansion-panel
		id="exposition-property-panel"
		[expanded]="vo.columnsConfigMode === 'COLUMNS_PARAMETER'"
		(opened)="setColumnsConfigMode('COLUMNS_PARAMETER')">
		<mat-expansion-panel-header
			[ngClass]="vo.columnsConfiguration.errors.size === 0 ? 'valid-step': 'invalid-step'">
			<mat-panel-title
				i18n="@@expositions.stepper.columnsConfig.parameterStep.title">
				columns-config-parameter-step-title</mat-panel-title>
			<mat-panel-description>
				<span
					i18n="@@expositions.stepper.columnsConfig.parameterStep.description">
					columns-config-parameter-step-description</span>
				<mat-icon
					*ngIf="vo.columnsConfiguration.errors.size === 0"
					[svgIcon]="DcIcons.Check"></mat-icon>
			</mat-panel-description>
		</mat-expansion-panel-header>

		<app-panel
			headerHeight="3rem"
			class="app-card-outline__columns"
			isAlwaysOpen="true"
			hasSearchableGrid="true"
			[actionsAvailable]="columnsConfigGrid.selectionCount"
			[itemsCount]="vo.columnsConfiguration.elements.size"
			[actions]="vo.columnConfigActions"
			(search)="columnsConfigGrid.search($event)">
			<span panel-title
						i18n="@@exposition.access.list.column.columns">
				columns
			</span>
			<div class="exposition-column-step-panel-info" panel-info>
				<ng-container *ngIf="vo.columnsConfiguration.errors.size > 0 &&
						vo.columnsConfiguration.errors.has(ColumnConfigErrorKey.InvalidField)">
					<div class="invalid-columns-alert">
						<mat-icon [svgIcon]="DcIcons.Warning"></mat-icon>
						<span
							i18n="@@expositions.columns.config.alert.invalidField">
							invalid_alias
						</span>
					</div>
				</ng-container>
				<ng-container
					*ngIf="
						vo.columnsConfiguration.errors.size > 0 &&
						vo.columnsConfiguration.errors.has(ColumnConfigErrorKey.DuplicatedAlias)
					">
					<div class="invalid-columns-alert">
						<mat-icon color="warn" [svgIcon]="DcIcons.Warning"></mat-icon>
						<span
							i18n="@@expositions.columns.config.alert.duplicateAlias">
							duplicated_alias
						</span>
					</div>
				</ng-container>
			</div>
			<app-exposition-columns-config
				#columnsConfigGrid="ColumnsGrid"
				[columnConfigList]="vo.columnsConfiguration"
				[isInViewMode]="false"
				[isInAccessConfigMode]="false"
				[columnConfigMode]="'PARAMETER'"
				(errors)="modifyColumnConfigValidity()"></app-exposition-columns-config>
		</app-panel>

		<mat-action-row>
			<button
				mat-flat-button
				id="exposition-col-order-btn"
				color="primary"
				[disabled]="vo.columnsConfiguration.errors.size !== 0"
				(click)="nextColumnsConfigMode()">
				<span
					i18n="@@expositions.stepper.columnsConfig.orderStep">
					order-step</span>
			</button>
		</mat-action-row>
	</mat-expansion-panel>

	<mat-expansion-panel [expanded]="vo.columnsConfigMode === 'COLUMNS_ORDER'"
											 (opened)="setColumnsConfigMode('COLUMNS_ORDER')">
		<mat-expansion-panel-header [ngClass]="'valid-step'">
			<mat-panel-title
				i18n="@@expositions.stepper.columnsConfig.orderStep.title">
				columns-config-order-step-title</mat-panel-title>
			<mat-panel-description>
					<span
						i18n="@@expositions.stepper.columnsConfig.orderStep.description">
						columns-config-order-step-description</span>
				<mat-icon [svgIcon]="DcIcons.Check"></mat-icon>
			</mat-panel-description>
		</mat-expansion-panel-header>

		<app-panel
			headerHeight="3rem"
			class="app-card-outline__columns"
			isAlwaysOpen="true"
			hasSearchableGrid="true"
			[actionsAvailable]="columnsOrderGrid.selectionCount"
			[itemsCount]="vo.columnsOrder.elements.size"
			(search)="columnsOrderGrid.search($event)">
			<span panel-title
						i18n="@@exposition.access.list.column.columns">
				columns
			</span>
			<app-exposition-columns-config
				#columnsOrderGrid="ColumnsGrid"
				[columnConfigList]="vo.columnsOrder"
				[isInViewMode]="false"
				[isInAccessConfigMode]="false"
				[columnConfigMode]="'ORDER'"
				(movedElAction)="moveAction($event)"></app-exposition-columns-config>
		</app-panel>

		<mat-action-row>
			<button
				mat-flat-button
				id="exposition-col-conf-btn"
				color="primary"
				(click)="previousColumnsConfigMode()">
				<span
					i18n="@@expositions.stepper.columnsConfigStep">
					config-step</span>
			</button>
		</mat-action-row>
	</mat-expansion-panel>
</mat-accordion>
